import ElasticService from "src/services/elasticService";
import { RootState } from "src/store";

import { createSlice } from "@reduxjs/toolkit";
import UserSettingsService from "@services/userSettingsService";

type BetaKey = string;

type BetaState = Record<BetaKey, boolean | undefined>;

const availableFeatures: { key: BetaKey; probability: number }[] = [];

const initialState: BetaState = {};

type Key = (typeof availableFeatures)[number]["key"];

const initializeState = () => {
    const state = UserSettingsService.getBetaFeatures() || initialState;

    availableFeatures.forEach((item) => {
        if (state[item.key] === undefined) {
            state[item.key] = Math.random() * 100 < item.probability;
        }
    });
    UserSettingsService.setCommonValue("betaFeatures", state);

    return state;
};

const betaSlice = createSlice({
    name: "beta",
    initialState: initializeState(),
    reducers: {
        setBetaFeatureActive(state, { payload }: { payload: { key: Key; value: boolean; userEmail: string } }) {
            state[payload.key] = payload.value;
            UserSettingsService.setCommonValue("betaFeatures", state);

            ElasticService.createTransaction("betaFeature", {
                feature: payload.key,
                action: payload.value,
                user_email: payload.userEmail,
            });
        },
    },
});

export default betaSlice.reducer;

const _setBetaFeatureActive = betaSlice.actions.setBetaFeatureActive;

const _getBetaFeature = (state: RootState, key: Key) => state.beta[key];
